import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "d-none d-sm-inline" };
const _hoisted_2 = { class: "pa-4 pb-2" };
const _hoisted_3 = { class: "d-flex align-center" };
const _hoisted_4 = { class: "ml-3" };
const _hoisted_5 = { class: "text-body-1 font-weight-medium" };
const _hoisted_6 = { class: "text-caption text-medium-emphasis" };
const _hoisted_7 = { class: "mb-4" };
const _hoisted_8 = { class: "text-body-2 font-weight-medium" };
const _hoisted_9 = { class: "mb-4" };
const _hoisted_10 = {
    key: 0,
    class: "text-body-2 text-medium-emphasis"
};
const _hoisted_11 = { class: "text-caption" };
const _hoisted_12 = { key: 0 };
const _hoisted_13 = { key: 1 };
const _hoisted_14 = {
    key: 2,
    class: "text-caption"
};
const _hoisted_15 = { class: "text-body-2" };
const _hoisted_16 = { class: "text-body-2 text-medium-emphasis" };
const _hoisted_17 = { key: 0 };
const _hoisted_18 = ["innerHTML"];
import { ref, computed } from "vue";
import { useStore } from "@/store";
import { useAuthStore } from "@/stores/auth";
import { useNotificationStore } from "@/stores/notifications";
export default /*@__PURE__*/ _defineComponent({
    __name: 'UserMenu',
    emits: ["logoutAction"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const store = useStore();
        const auth = useAuthStore();
        const notifications = useNotificationStore();
        const showServerConfigDialog = ref(false);
        const infoDialog = ref(false);
        // Environment config
        const downloadReadmeYaml = process.env.VUE_APP_OFFER_DTOOL_README_YAML_DOWNLOAD === "true";
        const downloadReadmeJson = process.env.VUE_APP_OFFER_DTOOL_JSON_DOWNLOAD === "true";
        const showInfoMenuEntry = process.env.VUE_APP_SHOW_INFO_MENU_ENTRY === "true";
        const infoContent = process.env.VUE_APP_INFO_CONTENT || "Info Content";
        // Computed properties - use auth store for username
        const username = computed(() => auth.displayName || auth.username);
        const serverVersions = computed(() => store.server_versions);
        const lookupUrl = computed(() => store.lookup_url);
        // Computed property for user's accessible base URIs with permissions
        const userBaseUris = computed(() => {
            const searchSet = new Set(auth.searchPermissions);
            const registerSet = new Set(auth.registerPermissions);
            const allUris = new Set([
                ...auth.searchPermissions,
                ...auth.registerPermissions,
            ]);
            return Array.from(allUris).map((uri) => ({
                uri,
                canSearch: searchSet.has(uri),
                canRegister: registerSet.has(uri),
            }));
        });
        function formatPluginName(name) {
            // Convert snake_case to Title Case with spaces
            return name.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
        }
        function logout() {
            emit("logoutAction");
        }
        async function copyTokenToClipboard() {
            if (!auth.token) {
                notifications.error("No token available");
                return;
            }
            try {
                await navigator.clipboard.writeText(auth.token);
                notifications.success("Token copied to clipboard");
            }
            catch (error) {
                console.error("Failed to copy token:", error);
                notifications.error("Failed to copy token to clipboard");
            }
        }
        function getDtoolCommand(baseUri) {
            // Convert base URI like "s3://bucket-name" to dserver format "s3/bucket-name"
            const dserverPath = baseUri.replace("://", "/");
            return `dtool cp <dataset-uri> dserver://${dserverPath}`;
        }
        async function copyDtoolCommand(baseUri) {
            const command = getDtoolCommand(baseUri);
            try {
                await navigator.clipboard.writeText(command);
                notifications.success("Command copied to clipboard");
            }
            catch (error) {
                console.error("Failed to copy command:", error);
                notifications.error("Failed to copy command to clipboard");
            }
        }
        async function downloadFile(fileName) {
            const filePath = fileName === "dtool.json"
                ? process.env.VUE_APP_DTOOL_JSON_PATH || `data/templates/${fileName}`
                : process.env.VUE_APP_DTOOL_README_YAML_PATH ||
                    `data/templates/${fileName}`;
            try {
                const response = await fetch(filePath);
                if (!response.ok)
                    throw new Error("Network response was not ok");
                const text = await response.text();
                const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
                const downloadUrl = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = downloadUrl;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(downloadUrl);
                document.body.removeChild(a);
            }
            catch (error) {
                console.error("Failed to download file:", error);
            }
        }
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_avatar = _resolveComponent("v-avatar");
            const _component_v_divider = _resolveComponent("v-divider");
            const _component_v_list_item_title = _resolveComponent("v-list-item-title");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_list = _resolveComponent("v-list");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_menu = _resolveComponent("v-menu");
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle");
            const _component_v_tooltip = _resolveComponent("v-tooltip");
            const _component_v_table = _resolveComponent("v-table");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_spacer = _resolveComponent("v-spacer");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_component_v_menu, {
                    location: "bottom end",
                    "close-on-content-click": false
                }, {
                    activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps(props, {
                            variant: "tonal",
                            color: "primary",
                            class: "user-menu-btn"
                        }), {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, { start: "" }, {
                                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                            _createTextVNode("mdi-account-circle", -1)
                                        ]))]),
                                    _: 1
                                }),
                                _createElementVNode("span", _hoisted_1, _toDisplayString(username.value || "User"), 1),
                                _createVNode(_component_v_icon, { end: "" }, {
                                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                            _createTextVNode("mdi-menu-down", -1)
                                        ]))]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 16)
                    ]),
                    default: _withCtx(() => [
                        _createVNode(_component_v_card, {
                            "min-width": "280",
                            rounded: "lg"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createVNode(_component_v_avatar, {
                                            color: "primary",
                                            size: "40"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_icon, { color: "white" }, {
                                                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                                            _createTextVNode("mdi-account", -1)
                                                        ]))]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }),
                                        _createElementVNode("div", _hoisted_4, [
                                            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(auth).displayName || "User"), 1),
                                            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(auth).username), 1)
                                        ])
                                    ])
                                ]),
                                _createVNode(_component_v_divider),
                                _createVNode(_component_v_list, {
                                    density: "compact",
                                    nav: ""
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_list_item, {
                                            "prepend-icon": "mdi-content-copy",
                                            onClick: copyTokenToClipboard
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                            _createTextVNode("Copy token to clipboard", -1)
                                                        ]))]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_v_list_item, {
                                            "prepend-icon": "mdi-server",
                                            onClick: _cache[0] || (_cache[0] = ($event) => (showServerConfigDialog.value = true))
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                                            _createTextVNode("Server configuration", -1)
                                                        ]))]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }),
                                        downloadReadmeYaml
                                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                key: 0,
                                                "prepend-icon": "mdi-download",
                                                onClick: _cache[1] || (_cache[1] = ($event) => (downloadFile('dtool_readme.yml')))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, null, {
                                                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                                _createTextVNode("Download dtool_readme.yml", -1)
                                                            ]))]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true),
                                        downloadReadmeJson
                                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                key: 1,
                                                "prepend-icon": "mdi-download",
                                                onClick: _cache[2] || (_cache[2] = ($event) => (downloadFile('dtool.json')))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, null, {
                                                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                                _createTextVNode("Download dtool.json", -1)
                                                            ]))]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true),
                                        showInfoMenuEntry
                                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                                key: 2,
                                                "prepend-icon": "mdi-information",
                                                onClick: _cache[3] || (_cache[3] = ($event) => (infoDialog.value = true))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, null, {
                                                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                                                                _createTextVNode("Info", -1)
                                                            ]))]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true),
                                        _createVNode(_component_v_divider, { class: "my-1" }),
                                        _createVNode(_component_v_list_item, {
                                            "prepend-icon": "mdi-logout",
                                            "base-color": "error",
                                            onClick: logout
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                    default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                                            _createTextVNode("Logout", -1)
                                                        ]))]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }),
                _createVNode(_component_v_dialog, {
                    modelValue: showServerConfigDialog.value,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((showServerConfigDialog).value = $event)),
                    "max-width": "600"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_card, { rounded: "lg" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, { class: "d-flex align-center pa-4" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                            color: "primary",
                                            class: "mr-2"
                                        }, {
                                            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                                    _createTextVNode("mdi-server", -1)
                                                ]))]),
                                            _: 1
                                        }),
                                        _cache[18] || (_cache[18] = _createTextVNode(" Server Configuration ", -1))
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_divider),
                                _createVNode(_component_v_card_text, { class: "pa-4" }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_7, [
                                            _cache[19] || (_cache[19] = _createElementVNode("div", { class: "text-caption text-medium-emphasis mb-1" }, "Server URL", -1)),
                                            _createElementVNode("div", _hoisted_8, _toDisplayString(lookupUrl.value || "Not configured"), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_9, [
                                            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "text-caption text-medium-emphasis mb-2" }, "Base URIs", -1)),
                                            (userBaseUris.value.length === 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, " No base URIs accessible "))
                                                : (_openBlock(), _createBlock(_component_v_list, {
                                                    key: 1,
                                                    density: "compact",
                                                    class: "rounded-lg border"
                                                }, {
                                                    default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userBaseUris.value, (baseUri) => {
                                                            return (_openBlock(), _createBlock(_component_v_list_item, {
                                                                key: baseUri.uri,
                                                                class: "px-3"
                                                            }, {
                                                                prepend: _withCtx(() => [
                                                                    _createVNode(_component_v_icon, {
                                                                        size: "small",
                                                                        color: "primary"
                                                                    }, {
                                                                        default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                                                                _createTextVNode("mdi-database", -1)
                                                                            ]))]),
                                                                        _: 1
                                                                    })
                                                                ]),
                                                                append: _withCtx(() => [
                                                                    _createVNode(_component_v_tooltip, { location: "top" }, {
                                                                        activator: _withCtx(({ props }) => [
                                                                            _createVNode(_component_v_btn, _mergeProps({ ref_for: true }, props, {
                                                                                icon: "",
                                                                                size: "small",
                                                                                variant: "text",
                                                                                disabled: !baseUri.canRegister,
                                                                                onClick: ($event) => (copyDtoolCommand(baseUri.uri))
                                                                            }), {
                                                                                default: _withCtx(() => [
                                                                                    _createVNode(_component_v_icon, { size: "small" }, {
                                                                                        default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                                                                                                _createTextVNode("mdi-content-copy", -1)
                                                                                            ]))]),
                                                                                        _: 1
                                                                                    })
                                                                                ]),
                                                                                _: 1
                                                                            }, 16, ["disabled", "onClick"])
                                                                        ]),
                                                                        default: _withCtx(() => [
                                                                            _createElementVNode("div", _hoisted_11, [
                                                                                (baseUri.canRegister)
                                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Copy dtool command"))
                                                                                    : (_openBlock(), _createElementBlock("div", _hoisted_13, "Register permission required")),
                                                                                (baseUri.canRegister)
                                                                                    ? (_openBlock(), _createElementBlock("code", _hoisted_14, _toDisplayString(getDtoolCommand(baseUri.uri)), 1))
                                                                                    : _createCommentVNode("", true)
                                                                            ])
                                                                        ]),
                                                                        _: 2
                                                                    }, 1024)
                                                                ]),
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_v_list_item_title, { class: "text-body-2 font-weight-medium" }, {
                                                                        default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(baseUri.uri), 1)
                                                                        ]),
                                                                        _: 2
                                                                    }, 1024),
                                                                    _createVNode(_component_v_list_item_subtitle, { class: "text-caption" }, {
                                                                        default: _withCtx(() => [
                                                                            (baseUri.canSearch)
                                                                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                                                                    key: 0,
                                                                                    size: "x-small",
                                                                                    color: "info",
                                                                                    variant: "tonal",
                                                                                    class: "mr-1"
                                                                                }, {
                                                                                    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                                                                            _createTextVNode(" search ", -1)
                                                                                        ]))]),
                                                                                    _: 1
                                                                                }))
                                                                                : _createCommentVNode("", true),
                                                                            (baseUri.canRegister)
                                                                                ? (_openBlock(), _createBlock(_component_v_chip, {
                                                                                    key: 1,
                                                                                    size: "x-small",
                                                                                    color: "success",
                                                                                    variant: "tonal"
                                                                                }, {
                                                                                    default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                                                                            _createTextVNode(" register ", -1)
                                                                                        ]))]),
                                                                                    _: 1
                                                                                }))
                                                                                : _createCommentVNode("", true)
                                                                        ]),
                                                                        _: 2
                                                                    }, 1024)
                                                                ]),
                                                                _: 2
                                                            }, 1024));
                                                        }), 128))
                                                    ]),
                                                    _: 1
                                                }))
                                        ]),
                                        _createElementVNode("div", null, [
                                            _cache[27] || (_cache[27] = _createElementVNode("div", { class: "text-caption text-medium-emphasis mb-2" }, " Installed Plugins ", -1)),
                                            _createVNode(_component_v_table, {
                                                density: "compact",
                                                class: "rounded-lg"
                                            }, {
                                                default: _withCtx(() => [
                                                    _cache[26] || (_cache[26] = _createElementVNode("thead", null, [
                                                        _createElementVNode("tr", null, [
                                                            _createElementVNode("th", { class: "text-left" }, "Plugin"),
                                                            _createElementVNode("th", { class: "text-left" }, "Version")
                                                        ])
                                                    ], -1)),
                                                    _createElementVNode("tbody", null, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(serverVersions.value, (version, plugin) => {
                                                            return (_openBlock(), _createElementBlock("tr", { key: plugin }, [
                                                                _createElementVNode("td", _hoisted_15, _toDisplayString(formatPluginName(plugin)), 1),
                                                                _createElementVNode("td", _hoisted_16, _toDisplayString(version || "N/A"), 1)
                                                            ]));
                                                        }), 128)),
                                                        (Object.keys(serverVersions.value).length === 0)
                                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [...(_cache[25] || (_cache[25] = [
                                                                    _createElementVNode("td", {
                                                                        colspan: "2",
                                                                        class: "text-center text-medium-emphasis"
                                                                    }, " No plugins detected ", -1)
                                                                ]))]))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ]),
                                                _: 1
                                            })
                                        ])
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_divider),
                                _createVNode(_component_v_card_actions, { class: "pa-4" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                            variant: "tonal",
                                            color: "primary",
                                            onClick: _cache[4] || (_cache[4] = ($event) => (showServerConfigDialog.value = false))
                                        }, {
                                            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                                                    _createTextVNode(" Close ", -1)
                                                ]))]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_dialog, {
                    modelValue: infoDialog.value,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((infoDialog).value = $event)),
                    "max-width": "500"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_card, { rounded: "lg" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_card_title, null, {
                                    default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                                            _createTextVNode("Info", -1)
                                        ]))]),
                                    _: 1
                                }),
                                _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", { innerHTML: _unref(infoContent) }, null, 8, _hoisted_18)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_card_actions, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                            color: "primary",
                                            onClick: _cache[6] || (_cache[6] = ($event) => (infoDialog.value = false))
                                        }, {
                                            default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                                                    _createTextVNode("OK", -1)
                                                ]))]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ], 64));
        };
    }
});
